const CreateAndLoadRounds = () => {
  return (
    <div className="pt-8">
      <strong>To Create a Round Setup:</strong>
      <br />
      Enter a Round Setup name and select the options. You can set the time at
      the range before the course, the course for this round and the various
      options for the selected course. Click the &quot;Save Round Settings&quot;
      button when you are finished.
      <br />
      <br />
      <strong>To Load a Round Setup:</strong>
      <br />
      On the Dashboard page you can click on the &quot;Load Round&quot; button
      on any card that has an available sim (ie. a sim that is online with no
      currently active rounds). Clicking this button will open the Load Round
      popup with a form to create a new round. At the top of the form is a
      &quot;Saved Round Settings&quot; dropdown with options for all of the
      Saved Round Setups that have been created.
      <br />
      <br />
      Selecting a saved round setup will load the round form with all the saved
      options from that setup. You can make any adjustments you like and then
      click the &quot;Send to Sim&quot; button to send that round right to the
      simulator.
      <br />
      <br />
      <strong>To Delete a Round Setup:</strong>
      <br />
      Click on the &quot;Delete Saved Setups&quot; button on the left side of
      the &quot;Settings&quot; page. This will show a list of all Saved Round
      Setups. Click the &quot;Delete&quot; button next to the setup you want to
      delete and confirm.
    </div>
  );
};
export default CreateAndLoadRounds;
